'use strict';

import type { Ind } from '../../Entities/Ind/Ind';
import { EntityCollection } from '../EntityCollection';

export class IndCollection extends EntityCollection<Ind> {}
